
/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useState, useEffect } from 'react'
import './RentAI.css';
import AIheader from "./AIheader";
import BetaForm from "../../Component/BetaForm";
import 'react-phone-number-input/style.css'
//import { useNavigate } from 'react-router-dom';
import ContactForm from '../../Component/ContactForm/ContactForm.jsx'
//import ApiService from '../../classes/ApiService.jsx'
import Footer from "../../Component/Footer/Footer";
import { motion, AnimatePresence  } from "framer-motion";
import BetaWaitlist from '../../Component/Beta-Waitlist/BetaWaitlist.jsx';
//import JoinPriorityWaitlistBtn from '../../Component/ViralLoops/JoinPriorityWaitlistBtn.jsx';

const texts = [
    "manage bookings.",
    "rent vehicles.",
    "set smart rates.",
    "message guests.",
    "resolve issues.",
    "track your fleet.",
    "manage payments.",
    "enforce rules.",
    "get coverage.",
    "analyze trends.",
    "find resources.",
  ];

  
const RentAI = ()=> {
   
    const [index, setIndex] = useState(0);
    const [showWaitlist, setShowWaitlist] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
          setIndex((prevIndex) => (prevIndex + 1) % texts.length);
        }, 3000);
    
        return () => clearInterval(interval);
      }, []);


    return (
        <>
            <AIheader />
            <div className="rd-legacy">
            <section className="bannerAiMain">
                <div className="container">
                    <div className="bannerAiOuter">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="bannerAiLeft">
                                    <img alt="Rent AI Logo" src="/img/rentai/aiLogo.svg" />
                                    <small>AI Rental Task Agent</small>
                                    <h1> Meet rentii, your vehicle rental partner.</h1>
                                    <p>AI rental super agent that completes tasks, solves problems and gets things done for your business.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* START manageBookingsMain */}
            <section className='manageBookingsMain' id=''>
                <div className='container'>
                    <div className='manageBookingsOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='headManageBookings'>
                                <h2 classname="anim">
                                <span>rentii</span> helps you{" "}
                                <span className="grade_1">
                                    <AnimatePresence mode="wait">
                                    <motion.span
                                    key={index}
                                    className="affiliatePartnerGradient"
                                    data-text="enforce rules."
                                    initial={{ y: "-100%", opacity: 0 }}
                                    animate={{ y: "0%", opacity: 1 }}
                                    exit={{opacity: 0 }}
                                    transition={{ duration: 0.5 }}
                                    style={{ position: "absolute", left: 0, whiteSpace: "nowrap" }}
                                >
                                    {texts[index]}
                                </motion.span>
                                    </AnimatePresence>
                                </span>
                                </h2>
                                <h4 id='sub-heading'>Your AI Co-Pilot for Smarter Car Rental Operations</h4>
                                <p>Not just a chatbot—Rentii is your 24/7 digital teammate, built to simplify your business. From vehicle onboarding to booking, renter questions, claims & violations, Rentii’s got you covered every step of the way.</p>
                                {/* <Link to="/?signup=waitlist" className="btn">Join Waitlist</Link> */}
                                {/* <JoinPriorityWaitlistBtn buttonclass="btn" buttonText="Join Waitlist"  /> */}
                                <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                                <button onClick={() => setShowWaitlist(true)} className="btn btnGradient">
                                    Join Waitlist
                                </button>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='manageBookingsInner'>
                                    <img className="img-fluid" src="/img/rentai/manage_bookings.png" alt="rent id" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END manageBookingsMain */}

            {/* START aiMarqueeMain */}
            <section className='aiMarqueeMain' id=''>
                <div className="aiMarqueeInner">
                    <h2>no code ai gets rental tasks completed quickly & efficiently.</h2>
                </div>
                <div className="aiMarquee">
                    {/* <!-- First Scrolling Text (Left) --> */}
                    <div className="scroll-container">
                        <div className="scroll-text">
                            <span>Rent Vehicles. <strong>Set Smart Rates.</strong> Message Guests. <strong>Resolve Issues.</strong> Track Your Fleet. Enforce Rules. <strong>Get Insurance.</strong> Analyze Trends.<strong> Find Resources.</strong> Organize Trips. <strong>Update Calendars.</strong> Customize Policies.<strong> Assign Mileage. </strong>Approve Requests. <strong>Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong> </span>
                            <span>Organize Trips. <strong>Update Calendars.</strong> Customize Policies. <strong>Assign Mileage.</strong> Approve Requests.<strong> Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong></span>
                            <span>Rent Vehicles. <strong>Set Smart Rates.</strong> Message Guests. <strong>Resolve Issues.</strong> Track Your Fleet. Enforce Rules. <strong>Get Insurance.</strong> Analyze Trends.<strong> Find Resources.</strong> Organize Trips. <strong>Update Calendars.</strong> Customize Policies.<strong> Assign Mileage. </strong>Approve Requests. <strong>Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong> </span>
                            <span>Organize Trips. <strong>Update Calendars.</strong> Customize Policies. <strong>Assign Mileage.</strong> Approve Requests.<strong> Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong></span>
                        </div>
                    </div>

                    {/* <!-- Second Scrolling Text (Right) - FIXED SPACING --> */}
                    <div className="scroll-container">
                        <div className="scroll-text reverse">
                            <span>Organize Trips. <strong>Update Calendars.</strong> Customize Policies. <strong>Assign Mileage.</strong> Approve Requests.<strong> Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong></span>
                            <span>Organize Trips. <strong>Update Calendars.</strong> Customize Policies. <strong>Assign Mileage.</strong> Approve Requests.<strong> Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong></span>
                            <span>Organize Trips. <strong>Update Calendars.</strong> Customize Policies. <strong>Assign Mileage.</strong> Approve Requests.<strong> Secure Deposits.</strong> Add Trip Fees.<strong> Review Claims.</strong></span>
                        </div>
                    </div>

                    {/* <!-- Third Scrolling Text (Left) --> */}
                    <div className="scroll-container">
                        <div className="scroll-text">
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Manage Add-OnsView. <strong>Trip History.</strong> Improve Ratings. <strong>Maximize Earnings.</strong> Manage Payment.</span>
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Manage Add-OnsView. <strong>Trip History.</strong> Improve Ratings. <strong>Maximize Earnings.</strong> Manage Payment.</span>
                        </div>
                    </div>

                    {/* <!-- Fourth Scrolling Text (Right) --> */}
                    <div className="scroll-container">
                        <div className="scroll-text reverse">
                            <span>Rent Vehicles.<strong> Set Smart Rates.</strong> Message Guests. <strong>Resolve Issues.</strong> Track Your Fleet. <strong> Enforce Rule.</strong> Get Insurance.<strong> Analyze Trend.</strong> Find Resources.</span>
                            <span>Organize Trips. Update Calendars. Customize Policies. Assign Mileage. Approve Requests. Secure Deposits. Add Trip Fees. Review Claims.</span>
                            <span>Rent Vehicles. Set Smart Rates. Message Guests. Resolve Issues. Track Your Fleet.  Enforce Rule. Get Insurance. Analyze Trend. Find Resources.</span>
                        </div>
                    </div>

                    {/* <!-- Fifth Scrolling Text (Left) --> */}
                    <div className="scroll-container">
                        <div className="scroll-text">
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                        </div>
                    </div>

                    {/* <!-- sixth Scrolling Text (Right) --> */}
                    <div className="scroll-container">
                        <div className="scroll-text reverse">
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Manage Add-OnsView. <strong>Trip History.</strong> Improve Ratings. <strong>Maximize Earnings.</strong> Manage Payment.</span>
                            <span>Validate Coverage. <strong>Offer Discounts.</strong> Edit Trip Details.<strong> Confirm Returns.</strong> Adjust Availability.<strong> Prioritize Tasks.</strong> Run Analytics. <strong>Schedule Maintenance.</strong> </span>
                            <span>Manage Add-OnsView. <strong>Trip History.</strong> Improve Ratings. <strong>Maximize Earnings.</strong> Manage Payment.</span>
                        </div>
                    </div>

                </div>
            </section>
            {/* END aiMarqueeMain */}

            {/* START trustWorthyMain */}
            <section className='trustWorthyMain' id=''>
                <div className='container'>
                    <div className='trustWorthyOuter'>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='headTrustWorthy'>
                                    <h2>Trustworthy AI made for your rental business.</h2>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='trustWorthyInner'>
                                    <h3>Your data, your rules.</h3>
                                    <p>We prioritize your privacy by ensuring it’s never used to train models or shared with
                                        third parties. You can confidently rely on our AI, knowing your information is protected
                                        and solely working for your benefit.</p>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='trustWorthyInner'>
                                    <h3>Powered rental workflows</h3>
                                    <p>You’re in control of how AI enhances your processes. From automating repetitive tasks
                                        to providing actionable insights, you decide when and where to apply AI, making it as
                                        flexible and adaptive as your business demands.</p>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='trustWorthyInner'>
                                    <h3>Transparency you can trust</h3>
                                    <p>We believe in keeping you informed every step of the way. Gain full visibility into
                                        how your data is used, understand when AI may need adjustments, and access the tools
                                        to refine its performance for future improvements. Trust starts with clarity.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END trustWorthyMain */}


            {/* START contactMain */}
            <ContactForm />
            {/* <section className='contactMain' id=''>
                <div className='container'>
                    <div className='contactOuter'>
                    <img className="contact_1" src="/img/rentai/union.svg" alt="rent id"/>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='contactLeft'>
                                    <h2>What’s your problem?</h2>
                                    <h3><span>rentii</span> can solve it.</h3>
                                    <p>Tell us about your rental challenges, and we'll take care of the rest. Powered by Rentii, 
                                    we're here to help owners work smarter and more efficiently. So, what's your problem?</p>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='contactRight'>
                           
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* END contactMain */}


            {/* END moreSolutionMain */}
            <section className='moreSolutionMain'>
                <div className='container'>
                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="moreSolutionHeading">
                                <h2>Discover more solutions</h2>
                                <p>Rental tools to help you scale your business</p>
                            </div>
                        </div>
                    </div>

                    <div className='moreSolutionOuter'>
                        <div className="moreSolutionInner moreSolutionGreen">
                            <a href="/rentdirect">
                                <div className="green_overlay"></div>
                                <figure><img src="/img/rent_direct_logo.svg" alt="logo" /></figure>
                            </a>
                        </div>
                        <div className="moreSolutionInner moreSolutionwhite">
                            <a href="/rent-id">
                                <div className="sky_overlay"></div>
                                <figure> <img src="/img/rent_id_logo.svg" alt="logo" /></figure>
                            </a>
                        </div>
                        <div className="moreSolutionInner moreSolutionRed">
                            <a href="/rentshield">
                                <div className="red_overlay"></div>
                                <figure><img src="/img/rent_shield_logo.svg" alt="logo" /></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionPurple">
                            <a href="/rentsuccess">
                                <div className="purple_overlay"></div>
                                <figure><img src="/img/rent_success_logo.svg" alt="logo" /></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionYellow">
                            <a href="/rentacademy">
                                <div className="yellow_overlay"></div>
                                <figure> <img src="/img/rent_academy_logo.svg" alt="logo" /></figure>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            {/* END moreSolutionMain */}

            </div>
            <Footer />
            <BetaForm />
        </>
    )
}
export default RentAI;